module.exports = __webpack_public_path__ + "static/media/new-york-34.1d9f630d.jpg";